import { render, staticRenderFns } from "./PrtFooter.vue?vue&type=template&id=61577916&"
import script from "./PrtFooter.js?vue&type=script&lang=js&"
export * from "./PrtFooter.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports